module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/6th/campaign_banner@2x_da73a2b30eb8bf529eaec98c273b0aa4.jpg";